//pages/eventos/clientes/premio/ResultadoEventoPage.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../../axiosConfig";
import "./ResultadoEventoPage.css";

export default function ResultadoEventoPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [premio, setPremio] = useState(null);
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setErro("Você precisa estar logado.");
      setLoading(false);
      return;
    }

    api
      .get(`/evento/resultado/${slug}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setPremio(res.data.premio);
      })
      .catch((err) => {
  console.error("Erro ao buscar prêmio:", err);
  const mensagem = err?.response?.data?.erro?.toLowerCase?.() || "";

  if (mensagem.includes("nenhum sorteio encontrado")) {
    setErro("⚠️ Você ainda não participou deste evento.");
  } else if (mensagem.includes("token")) {
    setErro("⚠️ Sua sessão expirou. Faça login novamente.");
  } else {
    setErro("Erro ao carregar seu prêmio. Tente novamente mais tarde.");
  }
})

      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="status-loading">Carregando resultado...</div>;
  if (erro) return <div className="erro">{erro}</div>;

  return (
    <div className="resultado-evento-wrapper">
      <h2>Resultado do Evento</h2>
      <p className="descricao">Você ganhou:</p>
      <h3 className="premio-nome">{premio?.nome || "Prêmio não identificado"}</h3>

      {premio?.imagem && (
        <img
          src={premio.imagem}
          alt={premio.nome || "Prêmio"}
          className="premio-imagem"
        />
      )}

      <p className="observacao-final">
        Você receberá um e-mail com as orientações sobre o seu prêmio.
      </p>

      <button
        onClick={() => navigate("/painel-cliente")}
        className="btn-voltar-painel"
      >
        ← Voltar ao Painel
      </button>
    </div>
  );
}
